import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  PodNgCoreModule,
  ValidationMessagesModule,
  ValidationClassDirectiveModule,
  PipesModule,
  EqualValidatorDirectiveModule,
} from 'pod-ng-core';
import { IntTelInputModule } from '../intl-tel-input/intl-tel-input.module';
import { Confirm2faSmsComponent } from './confirm-2fa-sms.component';
import { Set2faSmsComponent } from './set-2fa-sms.component';

@NgModule({
  declarations: [Set2faSmsComponent, Confirm2faSmsComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TranslateModule.forChild(),
    PodNgCoreModule.forChild(),
    ValidationMessagesModule,
    ValidationClassDirectiveModule,
    PipesModule,
    EqualValidatorDirectiveModule,
    IntTelInputModule,
  ],
  exports: [Set2faSmsComponent, Confirm2faSmsComponent],
  providers: [],
})
export class TwoFaFormsModule {}
